<template>
    <div>
        <TField label="Content">
            <div class="px-4 is-flex is-flex-direction-column" >
                <div class="tw-flex tw-items-center">
                    <TButton 
                        @click="openEditor"
                        class="tw-mr-2 tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                    ><span class="mdi mdi-pencil tw-mr-2"></span>Open page editor</TButton>
                    <TButton 
                        @click="showEditContentModal = true"
                        class="tw-mr-2 tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                    ><span class="mdi mdi-pencil tw-mr-2"></span>Edit email "from"</TButton>
                    <TestSend
                        :comm="comm"
                        :comm_type="'email'"
                        :content="{ site: site_blob, page: page_blob, from, fromName, replyTo }"
                        size=""
                    >
                    </TestSend>
                </div>
                <div
                    class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-z-50 tw-bg-white"
                    v-if="showEditor">
                    <Editor
                        widgetBucket='pagerunner_widgets_stable'
                        ref="editor"
                        :site_blob="site_blob"
                        :page_blob="page_blob"
                        assetUrl="/api/1/assets"
                        @changed="changed"
                        @saved="save"
                        @discarded="discard"
                    ></Editor>
                </div>
            </div>
        </TField>
        <TModal 
            v-model="showEditContentModal">
            <div class="tw-px-4">
            <div class="tw-text-2xl tw-mb-2">Edit Email "From"</div>
            <div class="tw-flex tw-flex-col tw-gap-2">
                <TField label="From address">
                    <TSimplePicker
                        style="width: 100% !important;"
                        button-class="tw-w-80 tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                        v-model="from"
                        :items="[
                            {
                                value: 'contact@roonlabs.com',
                                label: 'contact@roonlabs.com',
                            },
                            {
                                value: 'orders@roonlabs.com',
                                label: 'orders@roonlabs.com',
                            },
                            {
                                value: 'sales@roonlabs.com',
                                label: 'sales@roonlabs.com',
                            },
                            {
                                value: 'finance@roonlabs.com',
                                label: 'finance@roonlabs.com',
                            },
                            {
                                value: 'store@roonlabs.com',
                                label: 'store@roonlabs.com',
                            },
                            {
                                value: 'rma@roonlabs.com',
                                label: 'rma@roonlabs.com',
                            },
                        ]"
                        :format="val => val.label"
                    >
                    </TSimplePicker>
                </TField>
                <TField label="From name">
                    <input
                        v-model="fromName"
                        class="
                        tw-w-full
                        tw-appearance-none tw-border 
                        tw-rounded tw-w-full tw-py-2 tw-px-3 
                        tw-text-gray-700 tw-leading-tight 
                        tw-focus:tw-outline-none tw-focus:tw-shadow-outline"/>
                </TField>
                <TField label="Reply to (optional)">
                    <input
                        placeholder="name@roonlabs.com"
                        v-model="replyTo"
                        @input="e => { replyToError = !e.target.value ? false : !e.target.value.endsWith('@roonlabs.com'); $emit('update:contenterror', replyToError); }"
                        class="
                        tw-w-full
                        tw-appearance-none tw-border 
                        tw-rounded tw-w-full tw-py-2 tw-px-3 
                        tw-text-gray-700 tw-leading-tight 
                        tw-focus:tw-outline-none tw-focus:tw-shadow-outline"/>
                    <div v-if="replyToError" class="tw-ml-2 tw-text-xs tw-text-red-500">Reply to must end in @roonlabs.com</div>
                </TField>
            </div>
            <div class="tw-flex tw-justify-end">
                <TButton 
                    @click="showEditContentModal = false" 
                    class="tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                >Close</TButton>
            </div>
        </div>
        </TModal>
    </div>
</template>
<script>
import TestSend from '@/components/TestSend.vue'
import Editor   from '@roonlabs/pagerunner-editor/Editor.vue'
import axios from 'axios';
import { deepEqual } from '@/core/utils';

import {
    TButton,
    TModal,
    TSimplePicker,
    TField
} from '@roonlabs/vue-tailwind';

export default {
    name: 'EmailContent',
    components: {TestSend, Editor, TModal, TButton, TField, TSimplePicker},
    props: {
        comm: {
            required: true,
            type: Object
        },
        campaign_id: {
            type: String,
            required: true
        },
        comm_id: {
            type: String,
            default: 'new'
        },
        content: {
            type: Object,
            required: true
        },
        contenterror: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data() {
        return {
            page:         null,
            page_blob:    {},
            site_blob:    {},
            showEditor:   false,

            showEditContentModal: false,

            from:   'contact@roonlabs.com',
            fromName: 'Roon Labs',
            replyToError: false,
            replyTo: '',
        }
    },

    methods: {
        changed() {
            if (this.$refs.editor) {
                try {
                    this.page_blob = this.$refs.editor.exportPage();
                    console.log('SAVING', this.page_blob);
                    this.$emit('save', JSON.parse(JSON.stringify(this.formattedContent)));
                } catch {}
            }
        },
        save(blob, dont_hide = false) {
            console.log('SAVE',blob)
            this.page_blob = blob;
            this.$emit('save', JSON.parse(JSON.stringify(this.formattedContent)));
            if (!dont_hide) {
                this.$router.replace({name: this.$route.name});
                this.showEditor = false;
            }
        },
        discard() {
            console.log('DISCARD',this.page?.page_data?.page)
            this.$router.replace({name: this.$route.name});
            this.showEditor = false;
            this.page_blob = this.page?.page_data?.page;
            this.$emit('save', JSON.parse(JSON.stringify(this.formattedContent)));
        },
        async getPage() {
            try {
                const res = await axios.get(`/api/1/comms/${this.comm_id}/page`)
                const { page, site } = res.data;
                this.page = page;
                if (this.content?.emails[0]) {
                    this.page_blob = this.content.emails[0];
                    console.log('using provided page', this.page_blob)
                } else {
                    this.page_blob = JSON.parse(JSON.stringify(page?.page_data?.page || {}));
                    console.log('using page from source', this.page_blob)
                }
                this.site_blob = site.page_data.page;
                if (this.$route.query?.editor === 'open') {
                    this.showEditor = true;
                }
            } catch (e) {
                console.log(e)
            }
        },
        openEditor() {
            this.$router.replace({name: this.$route.name, query: { editor: 'open' }});
            this.showEditor = true;
        },
    },
    watch: {
        content() {
            this.page_blob = this.content.emails[0] || {};
        },
        from(newval, oldval) {
            if (!this.fromName || this.fromName == this.defaultFromNames[oldval]) {
                this.fromName = this.defaultFromNames[newval];
            }
            this.$emit('save', JSON.parse(JSON.stringify(this.formattedContent)));
        },
        fromName() {
            this.$emit('save', JSON.parse(JSON.stringify(this.formattedContent)));
        },
        replyTo() {
            this.$emit('save', JSON.parse(JSON.stringify(this.formattedContent)));
        }
    },
    computed: { 
        formattedContent() {
            return {
                opts: {
                    from:     this.from,
                    fromName: this.fromName,
                    replyTo:  this.replyTo
                },
                emails: [
                    {
                        ...this.page_blob,
                    }
                ]
            }
        },

        defaultFromNames() {
            return {
                    'contact@roonlabs.com': 'Roon Labs',
                    'orders@roonlabs.com': 'Roon Orders',
                    'sales@roonlabs.com':  'Roon Sales',
                    'finance@roonlabs.com': 'Roon Finance',
                    'store@roonlabs.com': 'Roon Store',
                    'rma@roonlabs.com': 'Roon RMA',
            }
        }
    },
    async created() {
        const { from, fromName, replyTo } = (this.content?.opts || {});
        await this.getPage();
        this.from     = from || 'contact@roonlabs.com';
        this.fromName = fromName || this.defaultFromNames[this.from];
        this.replyTo  = replyTo || '';
    }

}
</script>
